import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, dark = false }) {
  return (
    <p className={`font-mono text-[11px] uppercase tracking-[0.3em] ${dark ? "text-[#E3D9C8]" : "text-[#2F5D8C]"}`}>
      {children}
    </p>
  );
}
